<template>
    <div id="contatti" class="footer py-5">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="row">
                        <img src="@/assets/images/logo.png" class="footer-logo" width="100">
                    </div>
                    <div class="row">
                        <p class="py-2 footer-p">MC2 Comunicazione Sas<br>
                            di Migliozzi Marco e C.<br>
                            Via P.Dino Beretta, 5/7 - 20852 Villasanta (MB)<br>PI:05937030962</p>
                    </div>
                    <div class="row pb-3">
                        <img src="@/assets/images/instagram.png" class="footer-icon" height="23">
                        <img src="@/assets/images/facebook.png" class="footer-icon" height="23">
                    </div>
                    <div class="row">
                        <a href="#" class="footer-p" style="text-decoration: underline;">PRIVACY POLICY</a>
                    </div>
                    <div class="row">
                        <a href="#" class="footer-p" style="text-decoration: underline;">COOKIES POLICY</a></div>
                </div>

                <div class="col-xl-6">
                    <div class="row">
                        <p class="footer-p">Inviaci il tuo numero di telefono e ti chiameremo il
                            prima possibile</p></div>
                    <div class="row">
                        <div class="row px-3">
                            <input type="text" class="form-control my-3" id="inputName" placeholder="Nome:"
                                   style="border-radius: 20px; background-color: #c7c7c7;" v-model="form.name">
                            <input type="text" class="form-control" id="inputPhone" placeholder="Telefono:"
                                   style="border-radius: 20px; background-color: #c7c7c7;" v-model="form.phone">
                        </div>
                        <div class="row py-4 px-3">
                            <input type="checkbox" class="form-check-input ml-0" id="exampleCheck1" v-model="policy">
                            <label class="form-check-label text-white ml-4" for="exampleCheck1">Dichiaro di aver
                                accettato
                                la
                                privacy policy.</label>
                            <button class="btn button-gray py-0 ml-auto footer-button"
                                    v-on:click="sendMessageFooter">Invia
                            </button>
                        </div>
                    </div>


                    <div class="row">
                        <p class="footer-p">Oppure contattaci direttamente</p>
                    </div>
                    <div class="row">
                        <img src="@/assets/images/phone.png" class="pr-4 footer-logo-contact" height="20">
                        <p class="footer-p">039304038</p>
                    </div>
                    <div class="row">
                        <img src="@/assets/images/email.png" height="20" class="pr-3 footer-logo-contact">
                        <p class="footer-p">info@mc2comunicazione.com</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Footer",
        data() {
            return {
                form: {
                    name: '',
                    phone: ''
                },
                policy: false
            }
        },
        methods: {
            sendMessageFooter() {
                const api = axios.create({
                    baseURL: 'http://www.mc2comunicazione.com',
                    proxy: false,
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE',
                        'Access-Control-Allow-Headers': 'Content-Type, Authorization'
                    }
                })
                api.post('/mailserver/phone', this.form).then((r) => {
                    console.log(r)
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
</script>

<style scoped>

</style>